export const GRAPHQL_VARIABLES = {
  contentType: 'image/png'
};

export const QUERY = `
  query companiesOne($companyId: MongoID!, $from: Date!, $to: Date!){
    companiesOne(filter: {_id: $companyId}) {
        settlements(from: $from, to: $to){ date total failAmount}
    }
}
`;
